import { render, staticRenderFns } from "./BottomNav2.vue?vue&type=template&id=833c1d2c"
import script from "./BottomNav2.vue?vue&type=script&lang=js"
export * from "./BottomNav2.vue?vue&type=script&lang=js"
import style0 from "./BottomNav2.vue?vue&type=style&index=0&id=833c1d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports